import React from 'react';

export const AnalyzeAssetsStorage = () => {
  return <div> Analyze Assets Storage </div>;
};

AnalyzeAssetsStorage.propTypes = {};

AnalyzeAssetsStorage.defaultProps = {};
